import React, { useState, useEffect } from "react";
import { IconButton } from "@material-ui/core";
import SVG from "react-inlinesvg";
import { SliderReusableComponent } from "../../../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import { BackLogoIconButton } from "../../../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import BasicDetails from "./FastFoodBasicDetails";
import Availability from "./FastFoodAvailability";
import SizePricing from "./FastFoodSizePricing";
import Tags from "./FastFoodTags";
import Nutrition from "./FastFoodNutrition";
import Allergy from "./FastFoodAllergy";
import Personalization from "./FastFoodPersonalization";
import Customization from "./FastFoodCustomization";
import Services from "./FastFoodServices";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  get_item_details_from_item_id,
  update_item_menu_setup,
} from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import { AmealioLoader } from "../../../../../../../Loader/AmealioLoader";
import { useSelector } from "react-redux";

const FastFoodAddItem = (props) => {
  const [step, setStep] = useState(1);

  const navigateToStep = (stepNo) => {
    setStep(stepNo);
  };

  useEffect(() => {
    if (props && props.activeItemId && props.activeItemId.length > 2) {
      const token = props.auth.user.accessToken;
      props.get_item_details_from_item_id(props.activeItemId, token);
    }
  }, [props.activeItemId]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      console.log(props.menuCategoryItems.runingTrack);
      setStep(props.menuCategoryItems.runingTrack);
    }
  }, [props.menuCategoryItems && props.menuCategoryItems.runingTrack]);

  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="container-fluid">
            <div className="row">
              <div
                id="onboarding-scrollbar"
                className="p-lg-0 col-12 col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 onboarding_process_screen_left new-subscription-onboarding-component"
              >
                <div className="col-12">
                  <BackLogoIconButton
                    displayBackText={true}
                    displayArrow={true}
                    backButtonClicked={"/casual-fine-dining/menusetup"}
                  />
                </div>
                <AddItemMainReusable
                  step={step}
                  setStep={setStep}
                  navigateToStep={(stepNo) => navigateToStep(stepNo)}
                  menuCategoryItems={props.menuCategoryItems}
                />
              </div>
              <div className="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 loginsignup-rightside">
                <SliderReusableComponent
                  // displayBarButton={false}
                  displayHamburger={true}
                  headingText={"Menu Set Up - Add Items"}
                  paragraphOne="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphTwo="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  paragraphThree="Enter information diligently about your Business establishment. Users would like to know about your Business listed on our app. Take your time and fill information carefully"
                  bottomImage={require("../../../../../../../../assets/images/illustratorImage/Amealio_Illustrations-01.svg")}
                />
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export const AddItemMainReusable = (props) => {
  const [slider, setSlider] = useState(
    props.menuCategoryItems && props.menuCategoryItems.runingTrack > 7
      ? -200
      : 0
  );
  const information = useSelector((state) => {
    return {
      personalization_information:
        state.onboarding.restaurantDetails.personalization_information,
      allergic_information:
        state.onboarding.restaurantDetails.allergic_information,
      nutrition_information:
        state.onboarding.restaurantDetails.nutrition_information,
    };
  });
  return (
    <React.Fragment>
      <div
        className="onboarding_process_screen-button-map"
        style={{ padding: props.dash && 0 }}
      >
        <div className="d-flex align-items-center mobileProgressWraper position-relative">
          <IconButton
            className="enProgressPrev"
            onClick={() => {
              if (slider <= 0) {
                setSlider(slider + 30);
              }
            }}
          >
            <SVG
              src={require("../../../../../../../../assets/images/UserManagement/prev.svg")}
            />
          </IconButton>
          <div className="nav-scroller mb-4">
            <ul
              className="enStepNav nav list-unstyled d-flex justify-content-between"
              style={{
                width: 775,
                left: `${slider}px`,
              }}
            >
              <li
                onClick={() => props.navigateToStep(1)}
                className={
                  (props.menuCategoryItems &&
                    Object.entries(props.menuCategoryItems).length === 0) ||
                  (props.menuCategoryItems &&
                    props.menuCategoryItems.runingTrack === 1)
                    ? "doing"
                    : "done"
                }
                //className="doing"
              >
                <div className="stepNumber">01</div>
                <div className="text">Basic Details</div>
              </li>
              <li
                onClick={() => props.navigateToStep(2)}
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 2
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 2
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">02</div>
                <div className="text">Tag</div>
              </li>
              <li
                onClick={() => {
                  if (information.personalization_information) {
                    props.navigateToStep(3);
                  } else {
                    alert("Item is not eligible for Personalization");
                  }
                }}
                className={
                  !information.personalization_information
                    ? "cancel"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.currentState >= 3
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 3
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">03</div>
                <div className="text">Personalization</div>
              </li>
              <li
                onClick={() => {
                  if (information.allergic_information) {
                    props.navigateToStep(4);
                  } else {
                    alert("Item is not eligible for Allergy");
                  }
                }}
                className={
                  !information.allergic_information
                    ? "cancel"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.currentState >= 4
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 4
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">04</div>
                <div className="text">Allergy</div>
              </li>
              <li
                onClick={() => props.navigateToStep(5)}
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 5
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 5
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">05</div>
                <div className="text">Availability</div>
              </li>
              <li
                onClick={() => props.navigateToStep(6)}
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 6
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 6
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">06</div>
                <div className="text">Size & Pricing</div>
              </li>
              <li
                onClick={() => {
                  if (information.nutrition_information) {
                    props.navigateToStep(7);
                  } else {
                    alert("Item is not eligible for Nutrition");
                  }
                }}
                className={
                  !information.nutrition_information
                    ? "cancel"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.currentState >= 7
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 7
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">07</div>
                <div className="text">Nutrition</div>
              </li>
              <li
                onClick={() =>
                  props.menuCategoryItems &&
                  (props.menuCategoryItems.itemSize === "SINGLE" ||
                    props.menuCategoryItems.itemSize === "MULTIPLE")
                    ? alert("Item is not customizable")
                    : props.navigateToStep(8)
                }
                className={
                  props.menuCategoryItems &&
                  (props.menuCategoryItems.itemSize === "SINGLE" ||
                    props.menuCategoryItems.itemSize === "MULTIPLE")
                    ? "cancel"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.currentState >= 8
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.currentState >= 7
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">08</div>
                <div className="text">Customization</div>
              </li>
              <li
                onClick={() => props.navigateToStep(9)}
                className={
                  props.menuCategoryItems &&
                  props.menuCategoryItems.currentState >= 9
                    ? "done"
                    : props.menuCategoryItems &&
                      props.menuCategoryItems.runingTrack === 9
                    ? "doing"
                    : "todo"
                }
              >
                <div className="stepNumber">09</div>
                <div className="text">Services</div>
              </li>
            </ul>
          </div>
          <IconButton
            className="enProgressNext"
            onClick={() => {
              if (slider > -180) {
                setSlider(slider - 30);
              }
            }}
          >
            <SVG
              src={require("../../../../../../../../assets/images/UserManagement/next.svg")}
            />
          </IconButton>
        </div>

        {props.step === 1 && (
          <BasicDetails
            onChange={(v) => props.setStep(v)}
            itemAvailabilityPathName={props.itemPathName}
          />
        )}
        {props.step === 2 && <Tags onChange={(v) => props.setStep(v)} />}
        {props.step === 3 && (
          <Personalization onChange={(v) => props.setStep(v)} />
        )}
        {props.step === 4 && <Allergy onChange={(v) => props.setStep(v)} />}
        {props.step === 5 && (
          <Availability onChange={(v) => props.setStep(v)} />
        )}
        {props.step === 6 && <SizePricing onChange={(v) => props.setStep(v)} />}

        {props.step === 7 && <Nutrition onChange={(v) => props.setStep(v)} />}

        {props.step === 8 && (
          <Customization onChange={(v) => props.setStep(v)} />
        )}
        {props.step === 9 && (
          <Services
            onChange={(v) => props.setStep(v)}
            itemAvailabilityPathName={props.itemPathName}
          />
        )}
      </div>
    </React.Fragment>
  );
};

FastFoodAddItem.propTypes = {
  auth: PropTypes.object.isRequired,
  get_item_details_from_item_id: PropTypes.func.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  auth: state.auth,
  errors: state.errors.errors,
  menuCategoryItems: ownProps?.location?.pathname?.includes("admin")
    ? state.superAdminOnboarding.menuCategoryItems
    : state.onboarding.menuCategoryItems,
  activeItemId: ownProps?.location?.pathname?.includes("admin")
    ? state.superAdminOnboarding.activeItemId
    : state.onboarding.activeItemId,
});

export default connect(mapStateToProps, {
  get_item_details_from_item_id,
  update_item_menu_setup,
})(FastFoodAddItem);
